import PropTypes from "prop-types";
import { appendHttpsToUrl, formatImageUrlByDevice } from "../../helpers/Helper";
import Image from "next/image";
import Link from "next/link"; // Import the Link component from Next.js
import styles from "./PostImage.module.css";
import { useAppContext } from "@components/Provider";
import { useMemo } from "react";

const PostImage = (props) => {
  const { isLazyLoading = true } = props;
  let { isMobile } = useAppContext();

  const imageChimay = () => {
    if (!props.Name) return props.name;
    return props.Name;
  };

  const renderCaption = () => {
    const imageCaption = props.Caption || props.caption;
    let value = "";
    if (imageCaption && imageCaption.props && imageCaption.props.value) {
      value = imageCaption.props.value;
    } else if (imageCaption && typeof imageCaption === "string") {
      value = imageCaption;
    }
    if (value || props.Credited || props.credited) {
      let crediturl = props.Credit_Url;
      let credited =
        props.Credited || props.credited ? (
          <span className={styles.credit}>
            <span>Photo Credit: {props.Credited || props.credited}</span>
          </span>
        ) : null;
      if (crediturl) {
        credited =
          props.Credited || props.credited ? (
            <div>
              Photo Credit:
              <a href={crediturl} rel="noopener noreferrer" target="_blank">
                <span>{props.Credited || props.credited}</span>
              </a>
            </div>
          ) : null;
      }
      return (
        <div className={styles.captionText}>
          <img
            className={styles.camera}
            src={`${process.env.S3_IMAGE_URL}/Camera-Icon.svg`}
            alt="camera-icon"
            width="20"
            height="20"
          />
          {value.length > 0 || credited ? (
            <span dangerouslySetInnerHTML={{ __html: value }} style={{ paddingRight: "6px" }} />
          ) : null}
          {credited}
        </div>
      );
    }
  };

  const { Link: ImageLink } = props; // Rename to avoid conflict with the imported Link
  let image;
  let addProps = {};
  const normalizedStyle = useMemo(() => {
    const baseStyle = props.style ? { ...props.style } : {};
    const hasWidthControl =
      "width" in baseStyle || "maxWidth" in baseStyle || "minWidth" in baseStyle;
    const hasHeightControl =
      "height" in baseStyle || "maxHeight" in baseStyle || "minHeight" in baseStyle;

    if (hasWidthControl && !hasHeightControl) {
      baseStyle.height = "auto";
    }
    if (hasHeightControl && !hasWidthControl) {
      baseStyle.width = "auto";
    }

    return baseStyle;
  }, [props.style]);

  if (props.isFeaturedImage) {
    addProps["data-hero"] = true;
  }

  if (ImageLink && ImageLink.props && ImageLink.props.value) {
    image = (
      <Link
        href={ImageLink.props.value} // Use the Link component
        className="img-link"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Image
          className={props.className}
          src={
            props.ImageUrl
              ? appendHttpsToUrl(props.ImageUrl)
              : appendHttpsToUrl(
                  formatImageUrlByDevice(imageChimay(), isMobile ? "sm" : "md", props.size)
                )
          }
          alt={props.Alt_Text || props.alt_text || "postimage"}
          title={props.title || props.Title}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          width={props.width || 16}
          height={props.height || 9}
          style={normalizedStyle}
        />
      </Link>
    );
  } else {
    image =
      isLazyLoading === false ? (
        <Image
          className={`${props.className}`}
          src={
            props.ImageUrl
              ? appendHttpsToUrl(props.ImageUrl)
              : appendHttpsToUrl(
                  formatImageUrlByDevice(imageChimay(), isMobile ? "sm" : "md", props.size)
                )
          }
          alt={props.Alt_Text || props.alt_text || "postimage"}
          title={props.title || props.Title}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          width={props.width || 16}
          height={props.height || 9}
          style={normalizedStyle}
          priority={props.isFeaturedImage}
        />
      ) : (
        <Image
          className={props.className}
          src={
            props.ImageUrl
              ? appendHttpsToUrl(props.ImageUrl)
              : appendHttpsToUrl(
                  formatImageUrlByDevice(imageChimay(), isMobile ? "sm" : "md", props.size)
                )
          }
          alt={props.Alt_Text || props.alt_text || "postimage"}
          title={props.title || props.Title}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          width={props.width || 16}
          height={props.height || 9}
          style={normalizedStyle}
          loading="lazy"
        />
      );
  }

  return (
    <figure className={props.className}>
      {image}
      <figcaption>{renderCaption()}</figcaption>
    </figure>
  );
};

export default PostImage;

PostImage.propTypes = {
  Name: PropTypes.string,
  Caption: PropTypes.object,
  Alt_Text: PropTypes.string,
  Credited: PropTypes.string,
  Credit_Url: PropTypes.string,
  Link: PropTypes.object,
  ImageUrl: PropTypes.string,
  isLazyLoading: PropTypes.bool,
};
